import { ui } from "../../app/store.js";
import { V } from "../../app/pages.js";
import { can } from "../../services/access.js";
import { admUsers, admRoles } from "../admin/page.js";
import { accountActivationForm } from "../admin/workspace-tools.js";

V.accounts = () => {
  if (!can("admin.users"))
    return '<section class="panel"><h2>Account Management Is Restricted</h2><p class="muted">Your role does not have permission to manage accounts.</p></section>';
  const tab = ui.accountsTab === "roles" ? "roles" : "users";
  return `<div class="settings-page accounts-page"><p class="muted">Manage user access, sign-in accounts, and the permissions assigned to each role.</p><div class="settings-tabs" role="tablist" aria-label="Account Management Sections">${[
    ["users", "Users"],
    ["roles", "Roles & Permissions"],
  ]
    .map(
      ([key, label]) =>
        `<button type="button" role="tab" id="accounts-tab-${key}" aria-selected="${tab === key}" aria-controls="accounts-content" tabindex="${tab === key ? 0 : -1}" data-accounts-tab="${key}">${label}</button>`,
    )
    .join(
      "",
    )}</div><div id="accounts-content" role="tabpanel" aria-labelledby="accounts-tab-${tab}">${tab === "roles" ? admRoles() : admUsers() + accountActivationForm()}</div></div>`;
};
